import { render, staticRenderFns } from "./SaveWindow.vue?vue&type=template&id=4884bab4&scoped=true"
import script from "./SaveWindow.vue?vue&type=script&lang=js"
export * from "./SaveWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884bab4",
  null
  
)

export default component.exports